/** 首页路由 */
export default[
    {
        path:'setting',
        meta: {title: '设置'},
        name:'index',
        component: ()=>import('@/pages/setting/index.vue')
    }
]
